import React, { useRef, useState, useEffect } from 'react';
import styles from '../fortcan_securitycompany/fortcan_securitycompany.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';

const Fortcan_securitycompany: React.FC = () => {

    return (
        <div className={styles.fortcan_securitycompany}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "200px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>FORTCAN</h1>
                    <p >Monitoramento por câmeras com alta performance. Instalação, suporte e manutenção em RP e região.</p>
                    <div className={styles.links}>
                        <Link
                            href="https://api.whatsapp.com/send?phone=5516997601609&text=Ol%C3%A1%2C%20tudo%20bem%3F%0AGostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20instala%C3%A7%C3%A3o%20de%20c%C3%A2meras%20de%20seguran%C3%A7a%20residencial.%0APoderiam%20me%20enviar%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20e%20valores%3F%0A%0AObrigado(a)!"
                            title="Whatsapp"
                            icon={<WhatsappIcon color="#000000" height="40" />}
                            backgroundColor="#D59E28"
                            backgroundColorHover="#c7921fff"
                            colorText="#000000"
                        />
                        <Link
                            href="https://www.instagram.com/fortcan_securitycompany/?igsh=bnpvOWtnb24xMzdo&utm_source=qr#"
                            title="Instagram"
                            icon={<InstagramIcon color="#000000" height="32" />}
                            backgroundColor="#D59E28"
                            backgroundColorHover="#c7921fff"
                            colorText="#000000"
                        />
                        <Link
                            href="https://www.tiktok.com/@fortcansecurity?_t=ZM-8zGDOn2yFbq&_r=1"
                            title="TikTok"
                            icon={<TiktokIcon color="#000000" height="34" />}
                            backgroundColor="#D59E28"
                            backgroundColorHover="#c7921fff"
                            colorText="#000000"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Fortcan_securitycompany;
